'use client';

import { c as _c } from "react/compiler-runtime";
import { LayoutGroup } from 'framer-motion';
import type React from 'react';
import { useId } from 'react';
import { cn } from '../../../shared/cn';
export function NavbarSection(t0) {
  const $ = _c(11);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const id = useId();
  let t1;
  if ($[3] !== className) {
    t1 = cn(className, "flex items-center gap-4");
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div {...props} className={t1} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== id || $[9] !== t2) {
    t3 = <LayoutGroup id={id}>{t2}</LayoutGroup>;
    $[8] = id;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}